up.compiler('#env-banner', (element) => {
    var nav = document.querySelector('.navbar');
    if (nav != null) {
        nav.setAttribute("style", "top: " + element.offsetHeight + "px !important")
    }
})